import axios from 'axios';
import { getCookie, setCookie } from './cookieUtil';
import { API_SERVER_HOST, COOKIE_NAME } from '../Config';

const jwtAxios = axios.create();

const refreshJWT = async (accessToken, refreshToken) => {
  const host = API_SERVER_HOST;

  const header = { headers: { Authorization: `Bearer ${accessToken}` } };

  // const res = await axios.get(`${host}/api/member/refresh?refreshToken=${refreshToken}`, header);

  // console.log('----------------------');
  // console.log(res);

  // return res.data;
  try {
    const res = await axios.get(`${host}/api/member/refresh?refreshToken=${refreshToken}`, header);
    // console.log(res);

    return res.data;
  } catch (error) {
    // console.log('Error in refreshJWT:', error.response ? error.response.data : error.message);

    // error.response가 존재하는 경우, 서버에서 반환된 에러 데이터를 반환
    if (error.response) {
      return error.response.data;
    } else {
      // error.response가 없으면 네트워크 에러 또는 기타 예외 처리
      return { error: 'NETWORK_ERROR' };
    }
  }
};

//before request
const beforeReq = (config) => {
  // console.log('before request.............');

  const memberInfo = getCookie(COOKIE_NAME);

  if (!memberInfo) {
    // console.log('Member NOT FOUND');
    return Promise.reject({ response: { data: { error: 'REQUIRE_LOGIN' } } });
  }

  const { accessToken, refreshToken } = memberInfo;
  // Authorization 헤더 처리
  config.headers.Authorization = `Bearer ${accessToken}`;
  config.headers.RefreshToken = `Bearer ${refreshToken}`;

  return config;
};

//fail request
const requestFail = (err) => {
  // console.log('request error............', err);

  return Promise.reject(err);
};

//before return response
const beforeRes = async (res) => {
  // console.log('before return response...........');

  //'ERROR_ACCESS_TOKEN'
  const data = res.data;
  // console.log(data);
  if (data && data.error === 'ERROR_ACCESS_TOKEN') {
    const memberCookieValue = getCookie(COOKIE_NAME);

    const response = await refreshJWT(memberCookieValue.accessToken, memberCookieValue.refreshToken);
    if (response.error) {
      return response;
    }

    memberCookieValue.accessToken = response.accessToken;
    memberCookieValue.refreshToken = response.refreshToken;

    setCookie(COOKIE_NAME, JSON.stringify(memberCookieValue), 1);

    //원래의 호출
    const originalRequest = res.config;

    originalRequest.headers.Authorization = `Bearer ${response.accessToken}`;

    return await axios(originalRequest);
  }

  return res;
};

//fail response
const responseFail = (err) => {
  // console.log('response fail error.............', err);
  return Promise.reject(err);
};

jwtAxios.interceptors.request.use(beforeReq, requestFail);

jwtAxios.interceptors.response.use(beforeRes, responseFail);

export default jwtAxios;
